import toMillis from '../helpers/measurementSignals/toMillis'

// Een datumveld dat in Firestore in meer dan één vorm staat lezen als een
// lokale DAG, en die dag terugzetten in een <input type="date">. Het lezen van
// de vormen doet toMillis (één plek); dit voegt het afkappen op de dag en de
// weg terug naar het datumveld toe. Nodig omdat timestampToDateInput alleen een
// Timestamp kent en via toISOString in UTC rekent.

const pad = (n) => String(n).padStart(2, '0')

/**
 * @param {*} value - Timestamp, 'yyyy-mm-dd'-tekst, lege tekst of null
 * @returns {Date|null} De dag om 00:00 lokale tijd, of null
 */
export const storedDateToDay = (value) => {
    const ms = toMillis(value)
    if (ms === null) return null
    const date = new Date(ms)
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

/**
 * @param {Date|null} day
 * @returns {string} 'yyyy-mm-dd', of een lege tekst
 */
export const dayToInputValue = (day) => {
    if (!(day instanceof Date) || Number.isNaN(day.getTime())) return ''
    return `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`
}

export default storedDateToDay
